<template>
    <page :showBackButton="true" ref="page">
        <h1>Aktivierungscode einlösen</h1>
        <form @submit.prevent="submitForm()">
            <stepper v-model="step" :count="3">
                <stepper-item :step="1">
                    <base-input
                        id="activationcode"
                        v-model="formData.activationcode"
                        type="text"
                        label="Aktivierungscode"
                        class="ion-margin-bottom"
                        inputmode="numeric"
                    ></base-input>
                    <base-datetime
                        label="Geburtsdatum"
                        v-model="formData.birthdate"
                        id="birthdate"
                        :showNativeInput="true"
                        placeholder="TT.MM.JJJJ"
                        infoText="Das Geburtsdatum muss im Format TT.MM.JJJJ eingegeben werden."
                    ></base-datetime>
                </stepper-item>
                <stepper-item :step="2">
                    <p>
                        Bitte überprüfe deine Daten und klicke dann auf Weiter:
                    </p>
                    <ion-card class="-light">
                        <ion-list>
                            <ion-item>
                                <ion-label class="ion-text-wrap"
                                    >Anrede</ion-label
                                >
                                <ion-label class="ion-text-wrap ion-text-right"
                                    ><b>{{ userData.geschlecht }}</b>
                                </ion-label>
                            </ion-item>
                            <ion-item>
                                <ion-label class="ion-text-wrap"
                                    >Vorname</ion-label
                                >
                                <ion-label class="ion-text-wrap ion-text-right"
                                    ><b>{{ userData.vorname }}</b>
                                </ion-label>
                            </ion-item>
                            <ion-item>
                                <ion-label class="ion-text-wrap"
                                    >Nachname</ion-label
                                >
                                <ion-label class="ion-text-wrap ion-text-right"
                                    ><b>{{ userData.nachname }}</b>
                                </ion-label>
                            </ion-item>
                            <ion-item>
                                <ion-label class="ion-text-wrap"
                                    >E-Mail</ion-label
                                >
                                <ion-label class="ion-text-wrap ion-text-right"
                                    ><b>{{ formData.email }}</b>
                                </ion-label>
                            </ion-item>
                        </ion-list>
                    </ion-card>
                </stepper-item>
                <stepper-item :step="3">
                    <ion-card class="-light">
                        <ion-list-header class="u-m-bottom-none"
                            >Kommunikationsdaten</ion-list-header
                        >
                        <base-input
                            id="email"
                            v-model="formData.email"
                            type="email"
                            label="E-Mail (als Zustelladresse)"
                        ></base-input>
                        <base-input
                            id="emailcheck"
                            v-model="emailCheck"
                            type="email"
                            label="E-Mail wiederholen"
                        ></base-input>
                        <base-input
                            id="mobil"
                            v-model="formData.mobil"
                            type="tel"
                            label="Handynummer (für mTAN-Versand)"
                            :mask="{ mask: '+00/000/0000000000' }"
                            infoText="Die Handynummer muss im Format +43/664/1234567 eingegeben werden."
                            placeholder="+43/Vorwahl/Nummer"
                        ></base-input>
                        <base-input
                            id="kennwort"
                            v-model="formData.kennwort"
                            type="text"
                            label="Telefonisches Kennwort"
                            infoText="Dieses Kennwort dient bei telefonischen Kundenanfragen als Identifikationsmerkmal."
                        ></base-input>
                    </ion-card>
                    <ion-card style="padding-bottom: 0;" class="-light">
                        <ion-list-header class="u-m-bottom-none">
                            Ausweisdaten
                        </ion-list-header>
                        <base-select
                            v-model="formData.ausweisart"
                            id="ausweisart"
                            label="Ausweisart"
                        >
                            <ion-select-option value="Reisepass"
                                >Reisepass</ion-select-option
                            >
                            <ion-select-option value="Personalausweis"
                                >Personalausweis</ion-select-option
                            >
                            <ion-select-option value="Führerschein"
                                >Führerschein</ion-select-option
                            >
                        </base-select>
                        <base-input
                            type="text"
                            id="ausweisnummer"
                            label="Ausweisnummer"
                            v-model="formData.ausweisnummer"
                        ></base-input>
                        <base-input
                            type="text"
                            id="ausstellendebehoerde"
                            label="Ausstellende Behörde"
                            v-model="formData.ausstellendebehoerde"
                        ></base-input>
                        <base-datetime
                            label="Ausstellungsdatum"
                            v-model="formData.ausstellungsdatum"
                            id="ausstellungsdatum"
                            class="ion-margin-top ion-margin-bottom"
                            :showNativeInput="true"
                            placeholder="TT.MM.JJJJ"
                            infoText="Das Ausstellungsdatum muss im Format TT.MM.JJJJ eingegeben werden."
                        ></base-datetime>
                        <ion-label>Amtlicher Lichtbildausweis</ion-label>
                        <div
                            style="font-size: small;"
                            v-if="!shouldGetGenuineImages"
                        >
                            Erlaubte Dateiformate: <b>JPEG</b>, <b>PNG</b> oder
                            <b>PDF</b> (maximal 3 Dateien)
                        </div>
                        <files-upload
                            v-model="formData.file"
                            id="file"
                            :multiple="true"
                            class="u-m-bottom-none"
                            :shouldGetNativePhoto="true"
                            :maxFiles="3"
                            :shouldGetGenuineImages="shouldGetGenuineImages"
                            @genuineChange="formData.identifydata = $event"
                        ></files-upload>
                        <input-error id="general_not_approved"></input-error>
                    </ion-card>
                    <ion-card class="-light">
                        <ion-item lines="none">
                            <base-checkbox
                                v-model="formData.agb1"
                                id="formdata-agb1"
                            ></base-checkbox>
                            <ion-label text-wrap
                                >Ja, ich habe die
                                <a
                                    href="https://www.wuestenrot.at/content/dam/wuestenrot.at/dokumente/KS218_Verbraucherinfo_FernFinanzDienstleistungsgesetz.pdf"
                                    target="_blank"
                                    >Verbraucherinformation gemäß §§ 5ff
                                    Fern-Finanzdienstleitungsgesetz betreffend
                                    eServices</a
                                >
                                gelesen und zur Kenntnis genommen. Den
                                <a
                                    href="https://www.wuestenrot.at/content/dam/wuestenrot.at/dokumente/KS210B_AGBeServices.pdf"
                                    target="_blank"
                                    >Nutzungsbedingungen und der
                                    Datenschutzerklärung der Wüstenrot
                                    eServices</a
                                >
                                stimme ich zu.</ion-label
                            >
                        </ion-item>
                        <input-error id="agb1"></input-error>
                        <ion-item lines="none">
                            <base-checkbox
                                v-model="formData.agb2"
                                id="formdata-agb2"
                            ></base-checkbox>
                            <ion-label text-wrap
                                >Mit dem Login zu den Wüstenrot eServices stimme
                                ich der elektronischen Kommunikation
                                zu.</ion-label
                            >
                        </ion-item>
                        <input-error id="agb2"></input-error>
                    </ion-card>
                </stepper-item>
            </stepper>
        </form>
        <template v-slot:footer>
            <ion-grid>
                <ion-row>
                    <ion-col v-if="step > 1">
                        <ion-button expand="block" @click="step--"
                            >Zurück</ion-button
                        >
                    </ion-col>
                    <ion-col>
                        <ion-button
                            :disabled="
                                formData.activationcode === '' ||
                                formData.birthdate === ''
                            "
                            expand="block"
                            @click="submitForm()"
                            >Weiter</ion-button
                        >
                    </ion-col>
                </ion-row>
            </ion-grid>
        </template>
    </page>
</template>

<style scoped lang="scss"></style>

<script>
import Page from "@/components/Page";
import BaseInput from "@/components/BaseInput";
import Stepper from "@/components/Stepper";
import StepperItem from "@/components/StepperItem";
import FilesUpload from "@/components/FilesUpload";
import BaseDatetime from "@/components/BaseDatetime";
import BaseCheckbox from "@/components/BaseCheckbox";
import MtanModal from "@/components/MtanModal";
import {
    checkActivationCode,
    activateEservicesAccount,
} from "@/api/activation";
import InputError from "@/components/InputError";
import BaseSelect from "@/components/BaseSelect";
import ActivationInfoModal from "@/components/ActivationInfoModal";

// jenID ausgeblendet
// import { Plugins } from "@capacitor/core";
// const { GenuineIDPlugin } = Plugins;

export default {
    components: {
        Page,
        BaseInput,
        Stepper,
        StepperItem,
        FilesUpload,
        BaseDatetime,
        BaseCheckbox,
        InputError,
        BaseSelect,
    },
    methods: {
        submitForm(verifymtan = false, mtan = "") {
            if (this.step === 1) {
                this.$store.commit("setLoading", true);
                checkActivationCode(
                    this.formData.activationcode,
                    this.formData.birthdate
                ).then((response) => {
                    if (response.data.Status === 200) {
                        this.userData.geschlecht =
                            response.data.Result.geschlecht;
                        this.userData.vorname = response.data.Result.vorname;
                        this.userData.nachname = response.data.Result.nachname;
                        this.formData.email = response.data.Result.email;
                        this.step++;
                    }
                });
            } else if (this.step === 3) {
                if (this.formData.email === this.emailCheck) {
                    this.$store.commit("setLoadingSpinnerDuration", 120 * 1000);
                    this.$store.commit("setLoading", true);
                    let fullFormData = Object.assign({}, this.formData);
                    fullFormData.verifymtan = verifymtan;
                    fullFormData.mtan = mtan;
                    if (verifymtan) {
                        fullFormData.identifydata = "";
                    }
                    activateEservicesAccount(fullFormData)
                        .then((response) => {
                            if (response.data.Status === 200) {
                                if ("mtansend" in response.data.Result) {
                                    this.$ionic.modalController
                                        .create({
                                            component: MtanModal,
                                            backdropDismiss: false,
                                            componentProps: {
                                                propsData: {
                                                    mtansend:
                                                        response.data.Result
                                                            .mtansend,
                                                    submitFunctionName:
                                                        "submitForm",
                                                },
                                                parent: this,
                                            },
                                        })
                                        .then((m) => m.present());
                                } else {
                                    this.$ionic.modalController.dismiss();
                                    this.$ionic.modalController
                                        .create({
                                            component: ActivationInfoModal,
                                            componentProps: {
                                                propsData: {},
                                                parent: this,
                                            },
                                            backdropDismiss: false,
                                        })
                                        .then((m) => {
                                            m.onDidDismiss().then(() => {
                                                this.$router.push({
                                                    name: "login",
                                                });
                                            });
                                            m.present();
                                        });
                                }
                            }
                        })
                        .finally(() => {
                            this.$store.commit(
                                "setLoadingSpinnerDuration",
                                20 * 1000
                            );
                        });
                } else {
                    this.$refs.page.scrollToTop();
                    this.$ionic.alertController
                        .create({
                            header: "Bitte beachten",
                            message:
                                "Die eingegebenen E-Mail Adressen stimmen nicht überein.",
                            buttons: ["Ok"],
                        })
                        .then((a) => {
                            a.present();
                        });
                }
            } else {
                this.step++;
            }
        },
    },
    data() {
        return {
            step: 1,
            shouldGetGenuineImages: Capacitor.isNative,
            emailCheck: "",
            formData: {
                activationcode: "",
                birthdate: "",
                mobil: "",
                email: "",
                kennwort: "",
                file: [],
                ausweisart: "",
                ausweisnummer: "",
                ausstellendebehoerde: "",
                ausstellungsdatum: "",
                agb1: false,
                agb2: false,
                useidentifydata: Capacitor.isNative,
                identifydata: "",
            },
            userData: {
                geschlecht: "",
                vorname: "",
                nachname: "",
            },
        };
    },
    mounted() {
        // jenID ausgeblendet
        // if (Capacitor.isNative) {
        //     GenuineIDPlugin.isDeviceSupported().then((result) => {
        //         if (result.value !== undefined && result.value === false) {
        this.shouldGetGenuineImages = false;
        this.formData.useidentifydata = false;
        //         }
        //     });
        // }
        if (this.$store.state.nativeEnvironment === "development") {
            this.formData.activationcode = "8984040";
            this.formData.birthdate = "1980-01-01";
        }
    },
};
</script>
